import Vue from 'vue'
import router from './router'
import App from './App.vue'
import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'
import { TweenLite, TimelineMax, Power1, Power2, Power3, CSSPlugin } from "gsap/TweenMax";
import ScrollToPlugin from "gsap/ScrollToPlugin";

const plugins = [ TweenLite, CSSPlugin, TimelineMax, Power1, Power2, Power3, ScrollToPlugin ];

Vue.use(VueGlide)
Vue.config.productionTip = false

new Vue({
	router,
  	render: h => h(App),
}).$mount('#site_content')
